<template>
  <div>
    <b-card>
      <b-card-title
        class="fs-32 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span>Mostrar preço sem login?</span>
        </div>
      </b-card-title>

      <b-row>
        <b-col cols="12" class="d-flex align-items-center">
          <b-form-checkbox
            switch
            :checked="enabled"
            @change="enabled = !enabled"
          />

          <b-card-text v-if="enabled">
            <span style="color: green"> Mostrar preço mesmo sem login!</span>
          </b-card-text>

          <b-card-text v-if="!enabled">
            <span style="color: red"> Não mostrar preço sem login!</span>
          </b-card-text>
        </b-col>
      </b-row>

      <b-card-text class="mt-4">
        <br>
        <b-button
          variant="success"
          block
          @click="savePrice()"
        >Salvar</b-button>
      </b-card-text>
      
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'ActivePrice',
  mixins: [makeToast],
  data() {
    return {
      enabled: false,
    }
  },

  created(){
    this.getPrice();
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  methods: {
     ...mapActions('shopkeeper', ['saveActivePrice', 'getActivePrice']),

    getPrice(){
      this.$store.dispatch('startLoader');
      this.getActivePrice(this.dadosUsuario.id)
        .then((response) => {
          if(response.data.active_price) {
            this.enabled = response.data.active_price == 1 ? true : false;
          }
        })
        .catch(() => {
          this.makeToast('Opss!', 'Houve um erro ao atualizar!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    savePrice(){
      const data = {
        status: this.enabled,
        lojista_id: this.dadosUsuario.id
      }
      
      this.$store.dispatch('startLoader');
      this.saveActivePrice(data)
        .then((response) => {
          if(response.data.type == 'danger') {
            this.makeToast('Opss!', response.data.message, 'danger');
          } else {
            this.makeToast('Sucesso', response.data.message, 'success');
          }
        })
        .catch(() => {
          this.makeToast('Opss!', 'Houve um erro ao atualizar!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    }
  },
};
</script>
<style scoped>
.button-width {
  width: 100px;
}
</style>